import { IncidentsCreateRedirect } from '../../pages/incidents/IncidentsCreateRedirect';

const IncidentsList = async () =>
    import('../../pages/incidents/list/IncidentsListPage').then((module) => ({
        Component: module.IncidentsListPage,
    }));

const getIncidentsRoutes = () => {
    return [
        {
            path: '/incidents/create',
            element: <IncidentsCreateRedirect />,
        },
        {
            path: '/incidents/',
            lazy: IncidentsList,
        },
        {
            path: '/incidents/view/:viewId',
            lazy: IncidentsList,
        },
    ];
};

export { getIncidentsRoutes };
